import * as React from 'react';
import styled from 'styled-components';
import Colors from '../lib/Colors';

interface IProps {
  title?: React.ReactNode;
  className?: string;
  onGoBack?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}
function UnstyledCardWithHeader(props: IProps) {
  return (
    <section className={props.className}>
      {(props.title || props.onGoBack) && (
        <header>
          {props.onGoBack && (
            <button className="go-back" onClick={props.onGoBack}>
              <i className="fas fa-arrow-left fa-lg" />
            </button>
          )}
          {typeof props.title === 'string' ? (
            <div className="title">{props.title}</div>
          ) : (
            props.title
          )}
        </header>
      )}
      <section>{props.children}</section>
      {props.footer}
    </section>
  );
}

const CardWithHeader = styled(UnstyledCardWithHeader)`
  display: flex;
  flex-flow: column;
  width: 640px;
  max-width: calc(100% - 1rem);
  max-height: calc(100% - 1rem);
  overflow: hidden;
  border-radius: 0.2rem;

  @media (max-height: 414px), (max-width: 414px) {
    max-width: 100%;
    width: 100%;
    max-height: 100%;
    height: 100%;
    border-radius: 0;
  }

  margin: 0 auto;
  background: white;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);

  > header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    min-height: 3rem;
    height: 3rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    z-index: 1;
    font-size: 125%;
    text-align: center;

    .title {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      flex: 1;
      text-align: center;
    }

    button {
      color: ${Colors.primary};
      background: transparent;
      font-size: 1rem;
      height: 3rem;
      padding: 0.2rem 0.5rem;
      &:disabled {
        opacity: 0.3;
      }
      &.primary {
        background-color: ${Colors.primary};
        color: white;
      }
      &.go-back {
        color: black;
        opacity: 0.7;
      }
    }
  }

  > section {
    overflow: auto;
    flex: 1;
  }

  > footer {
    display: flex;
    min-height: 2.5rem;
    max-height: 3rem;
    height: 2.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    z-index: 1;
    button {
      background-color: ${Colors.primary};
      color: white;
      &:disabled {
        opacity: 0.3;
      }
    }
  }
`;
export default CardWithHeader;



// WEBPACK FOOTER //
// ./src/components/CardWithHeader.tsx